export const REQUIRED_MESSAGE = 'Campo Obrigatório'

export const NUMERO_CARTAO_INVALIDO = 'Número deve conter ao menos 14 dígitos.'

export const FORMATO_DATA_INVALIDO = 'Formato de data inválido. Favor usar o formato MM/AA.'

export const DATA_INVALIDA = 'Data Inválida'

export const CVV_INVALIDO = 'CVV deve conter 3 ou 4 dígitos.'

export const TEXTO_HELPER_CVV = 'Número de 03 a 04 dígitos localizado no verso ou frente do seu cartão'
